import { useHistory } from "react-router-dom"
import React, { useMemo, useEffect, useState, useRef } from 'react';
import { Row, Col, Card, CardBody, Modal, Input,
  TabContent,
  TabPane,
  NavLink,
  CardTitle,
  Nav,
  NavItem, } from "reactstrap"
  import { AvForm, AvField } from "availity-reactstrap-validation"
  import { toast,Slide } from 'react-toastify/dist/react-toastify';
  import MaterialReactTable from 'material-react-table';
  import { List,Edit,Download } from '@mui/icons-material';
  import { ExportToCsv } from 'export-to-csv';
  import {
    Box,
    Button,
    IconButton,
    Typography,
    Tooltip,
  } from '@mui/material';
import classnames from "classnames"
//Import Breadcrumb
import Select from "react-select"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableLoader from "../../components/Common/TableLoader"
import Axios from "../../helpers/axios_helper"
import * as sessionHelper from '../../helpers/session_helper';
import CustomModal from "../Common/CustomModal"
import PaymentPolicy from "./model"

const DatatableTables = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState(1);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  const selectedItem = useRef(0);
  const [modal_center, setmodal_center] = useState(false)
  const [update_status_modal_center, setUpdate_status_modal_center] = useState(false);

  const [paymentCoUser, setPaymentCoUser] = useState(false);
  const [userHasEditPermission, setUserHasEditPermission] = useState(false);
  const [courseDD, setCourseDD] = useState([]);
  const [courseId, setCourseId] = useState();
  const [paymentTypeDD, setPaymentTypeDD] = useState([]);
  const [paymentTypeId, setPaymentTypeId] = useState();
  const [installmentsDD, setInstallmentsDD] = useState([]);
  const [installmentId, setInstallmentId] = useState([]);
  const [statusDD, setStatusDD] = useState([]);
  const [statusId, setStatusId] = useState([]);
  const [overdueDD, setOverdueDD] = useState([]);
  const [overdueId, setOverdueId] = useState([]);

  const [columnFilters, setColumnFilters] = useState([]);
  const [columnFilterFns, setColumnFilterFns] = useState({
    academicEmail: 'contains',
    participantId: 'contains',
    academicContactNo: 'contains'
  });

  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const tableInstanceRef = useRef(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5
  });
  
  //#region Datatable

  const getStatusLabel = (statusValue,statusLabel='',badgeClass='') =>{
    switch (statusValue) {
      case '1':
        statusLabel = 'Not Initiated';
        badgeClass = 'badge badge-soft-secondary font-size-12';
        break;
      case '2':
        statusLabel = 'Processing';
        badgeClass = 'badge badge-soft-warning font-size-12';
        break;
      case '3':
        statusLabel = 'IPN Confirmed';
        badgeClass = 'badge badge-soft-info font-size-12';
        break;
      case '4':
        statusLabel = 'Validated';
        badgeClass = 'badge badge-soft-success font-size-12';
        break;
      case '5':
        statusLabel = 'Validation Failed';
        badgeClass = 'badge badge-soft-danger font-size-12';
        break;
      case '6':
        statusLabel = 'Failed';
        badgeClass = 'badge badge-soft-danger font-size-12';
        break;
      case '7':
        statusLabel = 'Canceled';
        badgeClass = 'badge badge-soft-danger font-size-12';
        break;
      default:
        statusLabel = 'N/A';
        badgeClass = 'badge badge-soft-dark font-size-12';
    }

    return {statusLabel,badgeClass}
  }

  const columns = useMemo(
    () => [
      {
        size:50,
        header: "#SL",
        accessorKey: 'sl',
        Cell: ({ cell, row }) => (
          <Typography variant='h7'>{cell.getValue()}</Typography>
        ),
        enableColumnFilterModes: false,
        enableColumnActions:false,
        enableSorting: false
      },
      {
        size:50,
        accessorKey: 'participantId',
        header: "Participant ID",
        Cell: ({ cell, row }) => (
          <Typography variant='h7'>{cell.getValue()}</Typography>
        ),
        enableColumnFilterModes: false,
        enableColumnActions:false,
        enableSorting: false
      },
      {
        size:50,
        accessorKey: 'learnerId',
        header: "Learner ID",
        Cell: ({ cell, row }) => (
          <Typography variant='h7'>{cell.getValue()??'-'}</Typography>
        ),
        enableColumnFilterModes: false,
        enableColumnActions:false,
        enableSorting: false
      },
      {
        accessorKey: 'academicFullName',
        header: "Full name",
        Cell: ({ cell, row }) => (
          <Typography variant='h7'>{cell.getValue()}</Typography>
        ),
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'academicContactNo',
        header: "Contact",
        Cell: ({ cell, row }) => (
          <Typography variant='h7'>{cell.getValue()}</Typography>
        ),
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'academicEmail',
        header: "Email",
        Cell: ({ cell, row }) => (
          <Typography variant='h7'>{cell.getValue()}</Typography>
        ),
        enableColumnFilterModes: false,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        header: "Course",
        accessorKey: 'enrolledCourseOrServices.course.courseName',
        Cell: ({ cell, row }) => (
          <Typography variant='h7' key={row.index}>{row.original['enrolledCourseOrServices.course.courseName']}</Typography>
        ),
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        header: "Course Code",
        accessorKey: 'enrolledCourseOrServices.course.courseCode',
        Cell: ({ cell, row }) => (
          <Typography variant='h7' key={row.index}>{row.original['enrolledCourseOrServices.course.courseCode']}</Typography>
        ),
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        size:50,
        accessorKey: 'enrolledCourseOrServices.campus',
        header: "Campus",
        Cell: ({ cell, row }) => (
          <Typography variant='h7'>{row.original['enrolledCourseOrServices.campus']}</Typography>
        ),
        enableColumnFilterModes: false,
        enableColumnActions:false,
        enableSorting: false
      },
      {
        size:50,
        accessorKey: 'enrolledCourseOrServices.classTime',
        header: "Batch",
        Cell: ({ cell, row }) => (
          <Typography variant='h7'>{row.original['enrolledCourseOrServices.classTime']}</Typography>
        ),
        enableColumnFilterModes: false,
        enableColumnActions:false,
        enableSorting: false
      },
      {
        header: "Payment Type",
        accessorKey: 'enrolledCourseOrServices.transactions.transactionType',
        Cell: ({ cell, row }) => (
          <Typography variant='h7' key={row.index}>{row.original['enrolledCourseOrServices.transactions.transactionType']==1?"Application Fee":`Installment No ${row.original['enrolledCourseOrServices.transactions.transactionInstallmentNo']}` }</Typography>
          // <Typography variant='h7' key={row.index}>{row.original['enrolledCourseOrServices.transactions.transactionType']==1?"Application Fee":`Course Fee` }</Typography>
        ),
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        header: "Transaction Amount",
        accessorKey: 'enrolledCourseOrServices.transactions.transactionInstallmentAmount',
        Cell: ({ cell, row }) => (
          <Typography variant='h7' key={row.index}>{row.original['enrolledCourseOrServices.transactions.transactionInstallmentAmount']??"-" }</Typography>
        ),
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        header: "Transaction Date",
        accessorKey: 'enrolledCourseOrServices.transactions.transactionDate',
        Cell: ({ cell, row }) => (
          <Typography variant='h7' key={row.index}>{row.original['enrolledCourseOrServices.transactions.transactionDate']??"-" }</Typography>
        ),
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        header: "Transaction Status",
        accessorKey: 'enrolledCourseOrServices.transactions.transactionStatus',
        Cell: ({ cell, row }) => {
          const status= getStatusLabel(row.original['enrolledCourseOrServices.transactions.transactionStatus']);
          return <span className={status.badgeClass}>{status.statusLabel}</span>;
        },
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      // {
      //   header: "Installment Date",
      //   Cell: ({ cell, row }) => (
      //     <Typography variant='h7'>{row.original['enrolledCourseOrServices.transactions.transactionInstallmentStartDate'] }</Typography>
      //   ),
      //   enableColumnFilterModes: true,
      //   filterFn: 'contains',
      //   columnFilterModeOptions: ['contains'],
      // },
      // {
      //   header: "Grace Period",
      //   Cell: ({ cell, row }) => {
      //     var color = '';
      //     if(row.original['enrolledCourseOrServices.transactions.transactionInstallmentGracePeriodOver']){
      //       color = 'red';
      //     }
      //     return <Typography variant='h7' style={{color:color}}>{row.original['enrolledCourseOrServices.transactions.transactionInstallmentGracePeriod']??"-" }</Typography>
      //   },
      //   enableColumnFilterModes: true,
      //   filterFn: 'contains',
      //   columnFilterModeOptions: ['contains'],
      // }
    ],
    [], 
  );

  const findFilterCondition = (name) => {
    var condition = '';
    if (columnFilterFns[name]) {
      condition = columnFilterFns[name];
    }
    return condition;
  }

  const fetchDataFromAPI = async (reset = false) => {
    if(!courseId){
      toast.error("Please select course !", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
        transition: Slide,
      });
      return;
    }
    else if(!paymentTypeId){
      toast.error("Please select payment type !", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
        transition: Slide,
      });
      return;
    }

    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }

    let filterQuery = '';
    let sorterQuery = '';

    if (!reset) {
      if (columnFilters.length > 0) {
        columnFilters.forEach(element => {
          filterQuery += `&filter=${element.id},${findFilterCondition(element.id)},${element.value}`;
        });
      }
      if (sorting.length > 0) {
        sorting.forEach(element => {
          sorterQuery += `&sortby=${element.id}&orderby=${element.desc ? 'desc' : 'asc'}`;
        });
      }
    } else {
      setPagination({
        pageIndex: 0,
        pageSize: 5
      });
      tableInstanceRef.current.resetRowSelection();
    }

    let installmentNoParam = installmentId;
    let statusParam = statusId;
    let overdueParam = overdueId;

    if(installmentNoParam.includes('-1')){
      installmentNoParam = -1
    }
    else{
      let selected = installmentNoParam && installmentNoParam.length>0 ? installmentNoParam.map(item => item.value) : [-1];
      installmentNoParam = selected.join('_')
    }
    if(statusParam.includes('-1')){
      statusParam = -1
    }
    else{
      let selected = statusParam && statusParam.length>0 ? statusParam.map(item => item.value) : [-1];
      statusParam = selected.join('_')
    }
    if(overdueParam.includes('-1')){
      overdueParam = -1
    }
    else{
      let selected = overdueParam && overdueParam.length>0 ? overdueParam.map(item => item.value) : [-1];
      overdueParam = selected.join('_')
    }

    const url = `/academicProfile/paymentHistoryByCourse/${courseId}&${paymentTypeId}&${installmentNoParam}&${statusParam}&${overdueParam}?limit=${pagination.pageSize}&offset=${pagination.pageIndex * pagination.pageSize}${sorterQuery}${filterQuery}`;
    await Axios.get(url)
      .then(function (response) {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
        if (response && response.data?.data) {
          // response.data?.data.forEach(element => {
          //   element.participantId=`${new Date(element.createdAt).getMonth()+element['id']}-${new Date(element.createdAt).getFullYear()+element['id']+new Date(element.createdAt).getMonth()+element['id']}`
          // });
          setData(response.data?.data);
          setRowCount(response.data.recordsTotal);
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        // navigate('/');
      });
  };

  useEffect(() => {
    if(!courseId && !paymentTypeId){
      return;
    }
    else
      fetchDataFromAPI();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting
  ]);

  useEffect(() => {
    if(!courseId && !paymentTypeId){
      return;
    }
    else
      fetchDataFromAPI(true);
  }, [
    activeTab
  ]);

  useEffect(async () => {
    if(sessionHelper.userHasEditPermission()){
      setUserHasEditPermission(true);
      await Axios.get('/open/course/dropdown')
        .then(function (response) {
          if (response && response.data.status==200) {
            let courseDD = response.data.data;
            let allCourse = {label:"All Course", value:"-1"};
            setCourseDD([allCourse,...courseDD]);
          }
          else {
            toast.error(response.statusText ?? "Data fetching failed !", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 3000,
              transition: Slide,
            });
          }
        })
        .catch(function (error) {
          // navigate('/');
        });
    }
    else{
      if(sessionHelper.userIsPaymentCO()){
        setPaymentCoUser(true);
      }
      await Axios.get('/user/access/dropdowns')
      .then(function (response) {
        if (response && response.data.status==200) {
          setCourseDD(response.data.courseDD);
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        // navigate('/');
      });
    }

    setPaymentTypeDD([
      {label:"All",value:-1},
      {label:"Application Fee",value:"1"},
      {label:"Course Fee",value:"2"}
    ]);

    setStatusDD([
      {label:"Not Initiated",value:1},
      {label:"Processing",value:2},
      {label:"SSL/IPN Confirmed",value:3},
      {label:"Validated",value:4},
      {label:"Validation Failed",value:5},
      {label:"Failed",value:6},
      {label:"Canceled",value:7}
    ]);

    setOverdueDD([
      // {label:"All",value:-1},
      {label:"Yes",value:1}
      // {label:"No",value:0}
    ])
  }, []);

  useEffect(() => {
    if(paymentTypeId && paymentTypeId==1){
      setInstallmentId([])
    }
  }, [paymentTypeId]);

  useEffect(async () => {
    setPaymentTypeDD([]);
    setInstallmentsDD([]);
    if(courseId && courseId==-1){
      setPaymentTypeDD([
        {label:"All",value:-1},
        {label:"Application Fee",value:"1"},
        {label:"Course Fee",value:"2"},
      ]);

      
      let InstallmentNos = [];
      // InstallmentNos.push({label:`One Time`,value:1});
      for (let index = 1; index < 10; index++) {
        InstallmentNos.push({label:`Installment No ${index}`,value:index});
      }
      setInstallmentsDD(InstallmentNos)
    }
    else if(courseId){
      await Axios.get(`/course/paymentPolicy/${courseId}&0`)
      .then((response) => {
          if (response.data?.status === 200) {
            let paymentTypes = [];
            let InstallmentNos = [];
              if(response.data.paymentPolicy){
                const haveApplicationFee = response.data.paymentPolicy.some(x=>x.transactionType==1);
                paymentTypes.push({label:"All",value:"-1"});
                if(haveApplicationFee){
                  paymentTypes.push({label:"Application Fee",value:"1"});
                }

                const policyInstallments = response.data.paymentPolicy.filter(x=>x.transactionType!=1);
                
                if(policyInstallments.length>0){
                  paymentTypes.push({label:"Course Fee",value:"2"});
                }
                setPaymentTypeDD(paymentTypes);

                // InstallmentNos.push({label:"All",value:"-1"});
                if(policyInstallments.length>1){
                  policyInstallments.forEach(element => {
                    InstallmentNos.push({label:`Installment No ${element.transactionInstallmentNo}`,value:element.transactionInstallmentNo});
                  });
                }
                else{
                  InstallmentNos.push({label:`One Time Payment`,value:1});
                }
                
                setInstallmentsDD(InstallmentNos);
                  // setPaymentPolicy(response.data.paymentPolicy);
              }
          }
          else{
            toast.error(response.data?.message ?? "Data fetching failed !", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 3000,
              transition: Slide,
            });
          }
      });
    }
  }, [courseId]);
  //#endregion

  //#region Modal

  const handleCallback = (response) =>{
    selectedItem.current=0;
    setmodal_center(false);
    fetchDataFromAPI(true);
  }

  const modalCallbackStatus = async (result) =>{
    if(result){
      updateActiveStatus(selectedItem.current);
    }
    setUpdate_status_modal_center(false);
    selectedItem.current=0;
  }

  const updateActiveStatus = async (id) =>{
    const url = `/course/changeStatus/${id}`;
    await Axios.patch(url)
      .then(function (response) {
        if (response && response.data?.status==200) {
          document.getElementById(`courseIsActive${id}`).innerHTML=response.data.courseIsActive==1?"True":"False"
          toast.success(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            transition: Slide,
          });
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        // navigate('/');
      });
  }

  const csvOptions = {
      filename:'Payment History',
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: true,
      headers: columns.map((c) => c.header),
    };
    
    const csvExporter = new ExportToCsv(csvOptions);
  
    const handleExportRows = (rows) => {
      const csvData = rows.map((row) => {
        const processedRow = {};
        columns.forEach((column) => {
            // Use column.header as the key and row.original[column.accessorKey] as the value
            if(column.accessorKey=='enrolledCourseOrServices.transactions.transactionStatus'){
              processedRow[column.header] = column.accessorKey
                ? getStatusLabel(row.original[column.accessorKey])?.statusLabel
                : '-';
            }
            else{
              processedRow[column.header] = column.accessorKey
                ? row.original[column.accessorKey]
                : '-';
            }
        });
        return processedRow;
    });
      csvExporter.generateCsv(csvData);
    };
  
    const handleExportData = () => {
      csvExporter.generateCsv(data);
    };
  
    const handlePageSizeChange = (newPageSize) => {
      setPagination({
        ...pagination,
        pageIndex: 0, // Reset to the first page when pageSize changes
        pageSize: newPageSize==-1?9999999:newPageSize,
      });
    };
  //#endregion

  return (
    <>
      <div className="page-content">

        <Breadcrumbs title="Payment" breadcrumbItem="History" />

        <Row>
          <Col className="col-12">
            <Card>
              <CardBody>
                <AvForm className="needs-validation" onSubmit={()=>{}}>
                  <Row>
                    <Col md={6} style={{zIndex:"93"}}>
                      <Row className="mb-3">
                        <label className="col-md-4 col-form-label">Course</label>
                        <div className="col-md-8">
                          <Select
                            name={"courseId"}
                            value={courseDD ? courseDD.find(x => x.value == courseId) : null}
                            id="courseId"
                            options={courseDD}
                            onChange={(e)=>{setCourseId(e.value);}}>
                          </Select>
                        </div>
                      </Row>
                    </Col>
                    <Col md={6}  style={{zIndex:"92"}}>
                      <Row className="mb-3">
                        <label className="col-md-4 col-form-label">Payment Type</label>
                        <div className="col-md-8">
                          <Select
                            name={"paymentTypeId"}
                            id="paymentTypeId"
                            value={paymentTypeDD ? paymentTypeDD.find(x => x.value == paymentTypeId) : null}
                            options={paymentTypeDD}
                            onChange={(e)=>{setPaymentTypeId(e.value)}}>

                          </Select>
                        </div>
                      </Row>
                    </Col>
                    {paymentTypeId && paymentTypeId=='2' &&
                    <Col md={6}  style={{zIndex:"91"}}>
                      <Row className="mb-3">
                        <label className="col-md-4 col-form-label">Installment No</label>
                        <div className="col-md-8">
                          <Select
                            name={"paymentTypeId"}
                            id="paymentTypeId"
                            options={installmentsDD}
                            isMulti={true}
                            value={installmentId}
                            onChange={(e)=>{setInstallmentId(e)}}>

                          </Select>
                        </div>
                      </Row>
                    </Col>}
                    <Col md={6} style={{zIndex:"90"}}>
                      <Row className="mb-3">
                        <label className="col-md-4 col-form-label">Status</label>
                        <div className="col-md-8">
                        <Select
                            name={"paymentTypeId"}
                            id="paymentTypeId"
                            options={statusDD}
                            isMulti={true}
                            value={statusId}
                            onChange={(e)=>{setStatusId(e)}}>

                          </Select>
                        </div>
                      </Row>
                    </Col>
                    <Col md={6} style={{zIndex:"90"}}>
                      <Row className="mb-3">
                        <label className="col-md-4 col-form-label">Overdue</label>
                        <div className="col-md-8">
                        <Select
                            name={"overdueId"}
                            id="overdueId"
                            options={overdueDD}
                            isMulti={true}
                            value={overdueId}
                            onChange={(e)=>{setOverdueId(e)}}>

                          </Select>
                        </div>
                      </Row>
                    </Col>
                    <Col md={paymentTypeId && paymentTypeId=='2' ? 6 : 12} style={{textAlign:"right",zIndex:"89"}}>
                    <button
                      type="button"
                      className="btn btn-primary waves-effect waves-light"
                      onClick={()=>{fetchDataFromAPI()}}
                    >
                      <i className="mdi mdi-database-search font-size-16 align-middle me-2"></i>{" "}
                        Search
                      </button>{" "}
                    </Col>
                  </Row>
                </AvForm>
                <br/>
                {/* <Nav tabs>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: activeTab === 1,
                      })}
                      onClick={() => {
                        setActiveTab(1)
                      }}
                    >
                      <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                      <span className="d-none d-sm-block">Active</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: activeTab === 0,
                      })}
                      onClick={() => {
                        setActiveTab(0)
                      }}
                    >
                      <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                      <span className="d-none d-sm-block">In-Active</span>
                    </NavLink>
                  </NavItem>
                </Nav> */}

                {true ?
                  <MaterialReactTable
                    columns={columns}
                    data={data}
                    enableColumnActions={false}
                    enableGlobalFilter={false}
                    enableColumnFilterModes
                    initialState={{
                      showColumnFilters: false
                    }}
                    manualFiltering
                    manualPagination
                    manualSorting
                    onColumnFilterFnsChange={setColumnFilterFns}
                    onColumnFiltersChange={setColumnFilters}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    tableInstanceRef={tableInstanceRef}
                    rowCount={rowCount}
                    enableEditing
                    state={{
                      columnFilters,
                      columnFilterFns,
                      globalFilter,
                      isLoading,
                      pagination,
                      showAlertBanner: isError,
                      showProgressBars: isRefetching,
                      sorting,
                    }}
                    positionActionsColumn="last"
                    displayColumnDefOptions={{
                      'mrt-row-actions': {
                        header: 'Action',
                      },
                    }}

                    renderRowActions={({ row, table }) => (
                      <Box sx={{ display: 'flex' }}>
                        <Tooltip arrow placement="left" title="Edit">
                          <IconButton onClick={() => {selectedItem.current=row.original;  setmodal_center(true)}}>
                            <Edit />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    )}
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{ display: 'flex', gap: '1rem', p: '0.5rem', flexWrap: 'wrap' }}
                      >
                        <Button
                          disabled={table.getRowModel().rows.length === 0}
                          //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)
                          onClick={() => handleExportRows(table.getRowModel().rows)}
                          startIcon={<Download />}
                          variant="contained"
                        >
                          Page Rows
                        </Button>
                        <Button
                          disabled={
                            !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                          startIcon={<Download />}
                          variant="contained"
                        >
                          Selected Rows
                        </Button>
                      </Box>
                    )}
                    enableRowSelection={true}
                    muiTablePaginationProps={{
                      rowsPerPageOptions: [5, 10, 25, 50, 100, { label: 'All', value: -1 }],
                      onRowsPerPageChange: (event) => {
                        handlePageSizeChange(Number(event.target.value));
                      },
                      showFirstButton: true,
                      showLastButton: true,
                    }}
                  />
                  :
                  <TableLoader />
                }
              </CardBody>
            </Card>
          </Col>
          <Modal
            size="lg"
            isOpen={modal_center}
            centered={true}>

            <div className="modal-header">
              <h5 className="modal-title mt-0">Transaction Details</h5>
              <button
                type="button"
                onClick={handleCallback}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              > 
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{padding:"0"}}>
              <PaymentPolicy transactionDetails={selectedItem.current} handleCallback={handleCallback}/>
            </div>
          </Modal>

          <CustomModal modelShow={update_status_modal_center} handleCallback={modalCallbackStatus}/>
          {/* <CustomModal modelShow={reset_modal_center} handleCallback={modalCallbackReset} bodyMsg={"New password will sent to the user through user email address."}/> */}
        </Row>
      </div>

    </>
  )
}

export default DatatableTables
